import { Directive, ElementRef, EventEmitter, HostListener, OnDestroy, Output } from '@angular/core';

// NOTE: you may have to run event.stopPropogation in your onclick methods/elements if nativelement.contains does not
// properly detect element nesting.
@Directive({
  selector: '[appClickOutside]'
})
export class ClickOutsideDirective {

  @Output() clickOutside = new EventEmitter<void>();

  constructor(private elementRef: ElementRef) { }

  @HostListener('document:click', ['$event.target'])
  public onClick(target) {
    const clickedInside = this.elementRef.nativeElement.contains(target);
    if (!clickedInside) {
      this.clickOutside.emit();
    }
  }
}
